import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { RoutesPaths } from '../routes/RoutesPathsEnum';
import NotFound from 'pages/NotFound';
import { getRoutes } from 'routes/routes';
import MainLayout from './MainLayout';
import OTPPage from 'pages/OTP/component';
import useAuth from 'features/auth/hooks/useAuth';
import { AuthProvider } from './AuthProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { handleSuccessfulLogin } from 'utils/helpers';

const Login = lazy(() => import('pages/Login/component'));
const Register = lazy(() => import('pages/Register/component'));

const AuthenticatedRoute = ({ children }: { children: JSX.Element }) => {
	const { getAccessToken } = useAuth();
	return getAccessToken() ? (
		children
	) : (
		<Navigate to={RoutesPaths.LOGIN} replace />
	);
};

const PublicRoute = ({ children }: { children: JSX.Element }) => {
	const { getAccessToken } = useAuth();
	const redirectUrl = handleSuccessfulLogin();
	return getAccessToken() ? <Navigate to={redirectUrl} replace /> : children;
};

function AppRoutes() {
	return (
		<BrowserRouter>
			<Suspense>
				<MainLayout>
					<Routes>
						<Route
							path={RoutesPaths.LOGIN}
							element={
								<PublicRoute>
									<Login />
								</PublicRoute>
							}
						/>
						<Route
							path={RoutesPaths.REGISTER}
							element={
								<PublicRoute>
									<Register />
								</PublicRoute>
							}
						/>
						<Route
							path={RoutesPaths.OTP}
							element={
								<PublicRoute>
									<OTPPage />
								</PublicRoute>
							}
						/>
						{getRoutes().map(({ path, element }) => (
							<Route
								key={path}
								path={path}
								element={
									<AuthenticatedRoute>
										{element}
									</AuthenticatedRoute>
								}
							/>
						))}
						<Route path='*' element={<NotFound />} />
					</Routes>
				</MainLayout>
			</Suspense>
		</BrowserRouter>
	);
}

function App() {
	return (
		<AuthProvider>
			<AppRoutes />
			<ToastContainer />
		</AuthProvider>
	);
}

export default App;
